<form class="security-form" [formGroup]="form">
  <h2>Change your password</h2>
  <input
    type="password"
    placeholder="Current password"
    formControlName="currentPassword"
  />
  <p class="error" *ngIf="showFieldError('currentPassword')">
    Current password is a required field
  </p>

  <input
    type="password"
    placeholder="New password"
    formControlName="newPassword"
  />
  <p class="error" *ngIf="showFieldError('newPassword')">
    New password is a required field
  </p>

  <input
    type="password"
    placeholder="Confirm your new password"
    formControlName="confirmPassword"
  />
  <p class="error" *ngIf="showFieldError('confirmPassword', 'required')">
    Confirm password is a required field
  </p>
  <p class="error" *ngIf="showFieldError('confirmPassword', 'equalsTo')">
    Confirm password must be equals to new password
  </p>

  <button mat-button (click)="onSubmit()">Save</button>
</form>
